import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, Ref } from "vue";
import { mande, defaults } from "mande";

interface Props {
    class?: string;
    videoUrl: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'universal-video',
  props: {
    class: { type: String, required: false },
    videoUrl: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const thumbnail: Ref<null | {
    width: number;
    height: number;
    url: string;
}> = ref(null);
const videoId: Ref<String | null> = ref(null);
const clicked: Ref<boolean> = ref(true);

const videoType = computed(() => {
    if (props.videoUrl && props.videoUrl !== "") {
        if (props.videoUrl.includes("youtu")) {
            return "youtube";
        } else if (props.videoUrl.includes("vimeo")) {
            return "vimeo";
        } else if (props.videoUrl.includes("instagram")) {
            return "instagram";
        }
        return "unknown";
    }
});

const embedUrl = computed(() => {
    switch (videoType.value) {
        case "youtube":
            return `https://www.youtube.com/embed/${videoId.value}?autoplay=1&modestbranding=1`;
        case "vimeo":
            return `https://player.vimeo.com/video/${videoId.value}?autoplay=1&loop=true&portrait=false&title=false`;
        default:
            return "";
    }
});

const getYoutubeVideoData = () => {
    // get video id from /ember or /watch url
    if (props.videoUrl!.includes("embed")) {
        videoId.value = props.videoUrl!.split("embed/")[1].split("&")[0];
    } else if (props.videoUrl!.includes("watch")) {
        videoId.value = props.videoUrl!.split("v=")[1].split("&")[0];
    } else if (props.videoUrl!.includes("shorts")) {
        videoId.value = props.videoUrl!.split("shorts/")[1].split("?")[0];
    } else if (props.videoUrl!.includes("youtu.be")) {
        videoId.value = props.videoUrl!.split("youtu.be/")[1].split("?")[0];
    } else {
        console.error("unknown youtube url");
    }
    // get thumbnail from youtube
    mande(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId.value}&format=json`)
        .get()
        // @ts-ignore
        .then((response: { thumbnail_url: string; thumbnail_width: number; thumbnail_height: number; width: number; height: number }) => {
            thumbnail.value = {
                width: response.width,
                height: response.height,
                url: response.thumbnail_url,
            };
        });
};

const getVimeoVideoData = () => {
    videoId.value = props.videoUrl!.split("vimeo.com/")[1].split("&")[0];

    const endpoint = "https://vimeo.com/api/oembed.json";

    fetch(`${endpoint}?url=${encodeURIComponent(props.videoUrl)}`, {
        method: "get",
        cache: "no-cache",
        mode: "cors",
    })
        .then((response) => {
            return response.json();
        })
        .then(
            (response: {
                type: string;
                version: string;
                provider_name: string;
                provider_url: string;
                title: string;
                author_name: string;
                author_url: string;
                is_plus: string;
                account_type: string;
                html: string;
                width: number;
                height: number;
                duration: number;
                description: string;
                thumbnail_url: string;
                thumbnail_width: number;
                thumbnail_height: number;
                thumbnail_url_with_play_button: string;
                upload_date: string;
                video_id: number;
                uri: string;
            }) => {
                thumbnail.value = {
                    width: response.thumbnail_width,
                    height: response.thumbnail_height,
                    url: response.thumbnail_url.split("_")[0] + ".jpg",
                };
            },
        )
        .catch((err) => console.log("ajax error -> ", err));
};

const getInstagramVideoData = () => {
    // set dummy first image
    thumbnail.value = {
        width: 100,
        height: 190,
        url: "/",
    };

    // load async script script www.instagram.com/embed.js
    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
};

const clearIubendaCookiesAndReset = () => {
    const cookies = document.cookie.split(";");
    const expiration = "Thu, 01 Jan 1970 00:00:01 GMT"; // Expire immediately
    const path = "/";

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const name = cookie.split("=")[0];

        if (name.startsWith("_iub_")) {
            document.cookie = name + "=; Path=" + path + "; Expires=" + expiration + ";";
            document.cookie = name + "=; Path=" + path + "; Domain=" + window.location.hostname + "; Expires=" + expiration + ";";
            document.cookie = name + "=; Path=" + path + "; Domain=." + window.location.hostname + "; Expires=" + expiration + ";";
        }
    }

    window.location.reload();
};

const isPurposeConsentGiven = (purposeId: any) => {
    // @ts-ignore
    if (window._iub && window._iub.cs && window._iub.cs.consent && window._iub.cs.consent.purposes) {
        // @ts-ignore
        const purposes = window._iub.cs.consent.purposes;
        // @ts-ignore
        return purposes[purposeId] === true;
    }

    return false;
};

switch (videoType.value) {
    case "youtube":
        getYoutubeVideoData();
        break;
    case "instagram":
        getInstagramVideoData();
        break;
    case "vimeo":
        getVimeoVideoData();
        break;
}

let cookiesAccepted = ref(false);
onMounted(() => {
    setTimeout(() => {
        cookiesAccepted.value = isPurposeConsentGiven(4);
    }, 1000);
});

const __returned__ = { props, thumbnail, videoId, clicked, videoType, embedUrl, getYoutubeVideoData, getVimeoVideoData, getInstagramVideoData, clearIubendaCookiesAndReset, isPurposeConsentGiven, get cookiesAccepted() { return cookiesAccepted }, set cookiesAccepted(v) { cookiesAccepted = v } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})